import { c as _c } from "react/compiler-runtime";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { cn } from "@/lib/utils";
type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
  control: Control<TFieldValues, TFieldName>;
  name: TFieldName;
  label?: string;
  type?: "text" | "number";
  className?: string;
};
export function InputForm(t0) {
  const $ = _c(8);
  const {
    control,
    name,
    label,
    type,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== label || $[2] !== type) {
    t1 = t2 => {
      const {
        field
      } = t2;
      const {
        value,
        ...fieldValues
      } = field;
      return <FormItem className="relative mt-2 flex flex-col"><FormLabel className="leading-5">{label}</FormLabel><FormControl><Input {...fieldValues} value={value ?? ""} type={type} onChange={e => {
            if (type === "number") {
              field.onChange(Number(e.target.value));
            } else {
              field.onChange(e);
            }
          }} className={cn("h-auto rounded-none bg-white p-4 text-sm focus:border-matchbus md:text-lg", className)} /></FormControl><FormMessage /></FormItem>;
    };
    $[0] = className;
    $[1] = label;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== control || $[5] !== name || $[6] !== t1) {
    t2 = <FormField control={control} name={name} render={t1} />;
    $[4] = control;
    $[5] = name;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}